var React = require('react');

function Tenge (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M372 160H12a12 12 0 0 0-12 12v56a12 12 0 0 0 12 12h140v228a12 12 0 0 0 12 12h56a12 12 0 0 0 12-12V240h140a12 12 0 0 0 12-12v-56a12 12 0 0 0-12-12z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M372 32H12A12 12 0 0 0 0 44v56a12 12 0 0 0 12 12h360a12 12 0 0 0 12-12V44a12 12 0 0 0-12-12z","className":"fa-primary","key":2})]);
}

Tenge.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Tenge;

Tenge.default = Tenge;
